import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {CrimeCategoryModel, CriminalModel, OverrideModel} from '../Models/criminal-model';
import {environment} from '../../../environments/environment';
import {ObjectUpdatePayload} from '../../models/screeningInvite';
import {tap} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CriminalRecord } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';

@Injectable({
  providedIn: 'root'
})
export class CriminalService {

  public snapshot: CrimeCategoryModel;

  // This facilitates the whole "selected record" thing we are doin with the criminal record list and having a record be visible on the dg settings tab for exclude records dialog.
  public selectedCrimRecord : CriminalRecord;

  constructor(private http: HttpClient, private toast: ToastrService) {
  }

  public getCrimes(clientId: number): Observable<CrimeCategoryModel> {
    return this.http.get<CrimeCategoryModel>(`${environment.baseURl}/api/decisionGrid/CrimeSubCategory/GetCrimeSubCategorySettings/${clientId}`)
      .pipe(
        tap((r: CrimeCategoryModel) => {this.snapshot = r},
        err => {
          this.toast.error('Error fetching criminal settings!', '', { closeButton: true, disableTimeOut: true })
        }));
  }

  public addSetting(clientId: number, data: CriminalModel): Observable<any> {

    // const p = {
    //   data: data,
    //   payload: payload,
    //   snapshot: this.snapshot
    // };



    return this.http.post<any>(`${environment.baseURl}/api/decisionGrid/CrimeSubCategory/InsertCrimeSubCategorySetting/${clientId}`, data)
      .pipe(tap(() => this.getCrimes(clientId).subscribe(),
      err => {
        this.toast.error('Error saving criminal setting!', '', { closeButton: true, disableTimeOut: true })
      }));

  }

  public updateSetting(clientId: number, data: CriminalModel): Observable<any> {
    // const p = {
    //   data: data,
    //   snapshot: this.snapshot
    // };

    let settingId = data.settingId;

    return this.http.post<any>(`${environment.baseURl}/api/decisionGrid/CrimeSubCategory/UpdateCrimeSubCategorySetting/${clientId}/${settingId}`, data)
      .pipe(tap(() => this.getCrimes(clientId).subscribe(),
      err => {
        this.toast.error('Error updating criminal setting!', '', { closeButton: true, disableTimeOut: true })
      }));
  }

  public saveGroupOverride(data: OverrideModel): Observable<any> {
    return this.http.post<any>(`${environment.baseURl}/api/decisionGrid/CrimeSubCategory/SaveGroupOverride`, data);
  }

  public removeGroupOverride(id: number, clientId: number): Observable<any> {
    return this.http.delete<any>(`${environment.baseURl}/api/decisionGrid/CrimeSubCategory/RemoveGroupOverride/${clientId}/${id}`);
  }
}

